import React from "react";
import { IconNames } from "../../../../shared/enums/orderStatusIcons";
import { AgentAiIcon } from "../../../../shared/svg/agent-ai-icon";
import HourGlassIcon from "../../../../shared/svg/hourglass-icon";
import HumanIcon from "../../../../shared/svg/humanIcon";
import WhiteCrossIcon from "../../../../shared/svg/whiteCrossIcon";
import WhiteTickIcon from "../../../../shared/svg/whiteTickIcon";
/**
 * Returns the background color and icon component to show for a given icon ID.
 *
 * This is used in `OverlappingIconsWithPopoverAndActionsCell`
 * to display status icons (stacked icons, hover tooltips, and click actions).
 *
 * Each icon gets:
 *  - a background color (used for the small circular badge),
 *  - a React component for the actual SVG icon inside the badge.
 *
 * If the icon ID is not recognized, a default grey background and no icon
 * are returned so the UI doesn't break.
 *
 * @param {string} icon_id - The icon's ID (usually from `IconNames`).
 * @returns {{ backgroundColor: string, iconComponent: React.ReactNode }}
 * An object containing the color and the icon component to render.
 */
export const getIconConfig = (
  icon_id: string,
): { backgroundColor: string; iconComponent: React.ReactNode } => {
  switch (icon_id) {
    case IconNames.ORDER_PROCESS_SUCCESS:
      return {
        backgroundColor: "#005D49",
        iconComponent: <HumanIcon />,
      };
    case IconNames.ORDER_PROCESS_YET_TO_START:
      return {
        backgroundColor: "#E6E6E6",
        iconComponent: <HumanIcon fill="black" />,
      };
    case IconNames.ORDER_PROCESS_IN_PROGRESS:
      return {
        backgroundColor: "#EF6C00",
        iconComponent: <HumanIcon />,
      };
    case IconNames.ORDER_PROCESS_SUCCESS_BY_AGENT:
      return {
        backgroundColor: "#E6E6E6",
        iconComponent: <AgentAiIcon />,
      };
    case IconNames.ORDER_IN_REVIEW:
      return {
        backgroundColor: "#EF6C00",
        iconComponent: <HourGlassIcon />,
      };
    case IconNames.ORDER_REVIEW_APPROVED:
      return {
        backgroundColor: "#00775E",
        iconComponent: <WhiteTickIcon />,
      };
    case IconNames.ORDER_REVIEW_REJECTED:
      return {
        backgroundColor: "#BB0202",
        iconComponent: <WhiteCrossIcon />,
      };
    case IconNames.AGENT_ORDER_REVIEW_PENDING:
      return {
        backgroundColor: "#EF6C00",
        iconComponent: <HumanIcon />,
      };
    default:
      return {
        backgroundColor: "#D1D1D1",
        iconComponent: null,
      };
  }
};
